import { useState } from "react";
import {
  Accordion,
  Divider,
  Flex,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { AddCircle, Minus } from "iconsax-react";

export type IAccordionDoubtsItem = {
  id: string;
  title: string;
  content: string;
};

type Data = IAccordionDoubtsItem;

interface IProps {
  data: Data[];
  firstOpen?: boolean;
  title?: string;
}

export default function AccordionDoubts({ data, firstOpen, title }: IProps) {
  const theme = useMantineTheme();
  const [value, setValue] = useState<string | null>(() => {
    if (data.length < 1) return null;

    if (firstOpen) return data[0].id;

    return null;
  });

  return (
    <Flex direction="column" gap="32px" w="100%">
      {title ? (
        <Title fw={700} size={24} lh={"32px"} color="basic.5">
          {title}
        </Title>
      ) : null}
      {data.length > 0 ? (
        <Accordion
          variant="separated"
          defaultValue={firstOpen ? data[0].id : null}
          onChange={setValue}
          value={value}
          w="100%"
          styles={() => ({
            chevron: {
              display: "none",
            },
            item: {
              border: `1px solid ${theme.colors.other[0]}`,
              background: theme.colors.basic[0],
              "&[data-active]": {
                color: theme.colors.basic[4],
                background: theme.colors.other[0],
              },
            },
            control: {
              fontSize: "16px",
              padding: "14px 12px",
            },
            label: {
              fontWeight: 500,
              marginLeft: "6px",
            },
            content: {
              padding: "0 12px 0 23px ",
            },
          })}
        >
          {data.map((id: Data, index: number) => (
            <Accordion.Item key={index} value={id.id}>
              <Accordion.Control
                icon={
                  value === id.id ? (
                    <Minus
                      size="24"
                      variant="Outline"
                      color={theme.colors.primary[0]}
                      style={{
                        border: `2px solid ${theme.colors.primary[0]}`,
                        borderRadius: "50px",
                      }}
                    />
                  ) : (
                    <AddCircle
                      size="24"
                      variant="Bold"
                      color={theme.colors.primary[0]}
                      style={{
                        border: `2px solid ${theme.colors.primary[0]}`,
                        borderRadius: "50px",
                      }}
                    />
                  )
                }
              >
                {id.title}
              </Accordion.Control>
              <Accordion.Panel>
                <Flex mb="24px">
                  <Divider
                    orientation="vertical"
                    size="md"
                    mr="24px"
                    color={theme.colors.primary[0]}
                  />
                  <Text
                    color="basic.4"
                    dangerouslySetInnerHTML={{
                      __html: id.content || "",
                    }}
                  />
                </Flex>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : null}
    </Flex>
  );
}
